import { Component, OnInit, Inject } from '@angular/core';
import { VERSION, MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'bil-report-view-modal',
  templateUrl: './report-view-modal.component.html',
  styleUrls: ['./report-view-modal.component.sass']
})
export class ReportViewModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ReportViewModalComponent>) {
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}